import { render, staticRenderFns } from "./BatteryPlugIcon.vue?vue&type=template&id=cd44b2ca&"
import script from "./BatteryPlugIcon.vue?vue&type=script&lang=js&"
export * from "./BatteryPlugIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports